import React, { useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import '../scss/features.style.scss';
import { featuresData } from '../constant/features-page.constant';
import { featureImages } from './images/jpg/featureImgaes';

const FeaturesComponent: React.FC = () => {
    const { t } = useTranslation();
    const [expandedCards, setExpandedCards] = useState<number[]>([]);

    const toggleCard = (index: number) => {
        setExpandedCards(prev => 
            prev.includes(index) 
                ? prev.filter(i => i !== index)
                : [...prev, index]
        );
    };

    // Helper function to get all paragraph keys from a feature
    const getParagraphs = (feature: any) => {
        const paragraphs = [];
        let paraIndex = 1;
        
        while (feature[`para${paraIndex}`]) {
            paragraphs.push(feature[`para${paraIndex}`]);
            paraIndex++;
        }
        
        return paragraphs;
    };

    return (
        <div className="features-page">
            {/* Main Features Section */}
            <section className="features-main-section">
                <Container>
                    <div className="features-main-header">
                        <Row>
                            <Col xs={12} md={6}>
                                <h2 className="features-main-title">
                                    {t('FEATURES_MAIN_TITLE')}
                                </h2>
                            </Col>
                            <Col xs={12} md={6}>
                                <p className="features-main-description">
                                    {t('FEATURES_MAIN_DESCRIPTION')}
                                </p>
                            </Col>
                        </Row>
                    </div>

                    {/* Features Grid */}
                    <div className="features-grid px-0">
                        <div className="features-custom-grid">
                            {featuresData.map((feature, index) => (
                                <div key={index} className="feature-card-wrapper">
                                    <div className={`feature-card ${expandedCards.includes(index) ? 'expanded' : ''}`}>
                                        <div className="feature-image">
                                            <img src={feature.image} alt={t(feature.titleKey)} />
                                        </div>
                                        <div className="feature-content ">
                                            <h3 className="feature-title">
                                                {t(feature.titleKey)}
                                            </h3>
                                            <p className="feature-description">
                                                {t(feature.descriptionKey)}
                                            </p>
                                            
                                            {/* Expandable content */}
                                            {expandedCards.includes(index) && getParagraphs(feature).length > 0 && (
                                                <div className="feature-expanded-content">
                                                    {getParagraphs(feature).map((paragraphKey, paraIndex) => (
                                                        <p key={paraIndex} className="feature-paragraph">
                                                            {t(paragraphKey)}
                                                        </p>
                                                    ))}
                                                </div>
                                            )}
                                            
                                            {/* Only show read more button if there are paragraphs to expand */}
                                            {getParagraphs(feature).length > 0 && (
                                                <button 
                                                    className="feature-read-more"
                                                    onClick={() => toggleCard(index)}
                                                >
                                                    <span>
                                                        {expandedCards.includes(index) 
                                                            ? t('FEATURES_READ_LESS') 
                                                            : t('FEATURES_READ_MORE')
                                                        }
                                                    </span>
                                                    <svg 
                                                        width="20" 
                                                        height="20" 
                                                        viewBox="0 0 20 20" 
                                                        fill="none"
                                                        className={expandedCards.includes(index) ? 'rotated' : ''}
                                                    >
                                                        <path 
                                                            d="M5 7.5L10 12.5L15 7.5" 
                                                            stroke="#6750B8" 
                                                            strokeWidth="1.66667" 
                                                            strokeLinecap="round" 
                                                            strokeLinejoin="round"
                                                        />
                                                    </svg>
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </Container>
            </section>

            {/* Revolut Section */}
            <section className="features-revolut-section">
                <Container>
                    <Row className="align-items-center">
                        <Col xs={12} md={6}>
                            <div className="revolut-content">
                                <h2 className="revolut-title">
                                    {t('FEATURES_REVOLUT_TITLE')}
                                </h2>
                                <p className="revolut-description">
                                    {t('FEATURES_REVOLUT_DESCRIPTION')}
                                </p>
                                <button className="revolut-btn" onClick={() => window.open('https://www.revolut.com/en-IN/referral/?referral-code=kevindtxd%21JUN1-25-AR-H2', '_blank')}>
                                    {t('FEATURES_REVOLUT_BUTTON')}
                                </button>
                            </div>
                        </Col>
                        <Col xs={12} md={6}>
                            <div className="revolut-image">
                                <img 
                                    src={featureImages.footer} 
                                    alt={t('FEATURES_REVOLUT_TITLE')} 
                                    className="revolut-img"
                                />
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </div>
    );
};

export default FeaturesComponent;
